import React, { useState, useEffect } from 'react';
import Banner from './Banner';
import RegistrationTypes from './RegistrationTypes';
import EntityCounts from './EntityCounts';
import SearchOpportunities from './SearchOpportunities';
import About from './About';
import Advertise from './Advertise';
import { FBOSearchPost, businessSearchGet } from '../../api';
import { FEDERAL_OPPORTUNITIES_GET_SELECT, BUSINESSES_GET_SELECT } from '../../constans';
import WhatsNewBannerHome from './WhatsNewBannerHome';

const Home = () => {
  const [federalContractsTotalCount, setFederalContractsTotalCount] = useState(0);
  const [businessTotalCount, setBusinessTotalCount] = useState(0)

  useEffect(() => {
    const fullTextParams = {
      select: FEDERAL_OPPORTUNITIES_GET_SELECT
    };

    FBOSearchPost(fullTextParams, {})
      .then(response => {
        setFederalContractsTotalCount(response.data.total_count)
      })
      .catch(error => {})
  }, [])

  useEffect(() => {
    const fullTextParams = {
      select: BUSINESSES_GET_SELECT
    };

    businessSearchGet(fullTextParams)
      .then(response => {
        setBusinessTotalCount(response.data.total_count)
      })
      .catch(error => {})
  }, [])

  return (
    <>
      <EntityCounts 
        federalContractsTotalCount={federalContractsTotalCount}
        businessTotalCount={businessTotalCount}
      />
      <Banner 
        federalContractsTotalCount={federalContractsTotalCount}
      />
      <RegistrationTypes />
      <WhatsNewBannerHome />
      <SearchOpportunities />
      <About />
      <Advertise />
    </>
  )
}

export default Home;